module.exports = __webpack_public_path__ + "static/media/close.09e70abb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/vectors/close.svg
// module id = 176
// module chunks = 0